<script setup lang="ts">
import type { File } from '~/types/api'

const props = defineProps<{
  images: File[]
}>()

const { visible, index, showImg } = useLightbox()
</script>

<template>
  <div class="overflow-hidden">
    <div class="container">
      <UiCarousel
        :opts="{
          align: 'start',
          loop: false,
          skipSnaps: true,
          dragFree: true,
        }"
        orientation="horizontal"
        class="block gap-4"
      >
        <UiCarouselPrevious
          class="group absolute left-2 top-1/2 z-10 mx-auto flex -translate-y-1/2 translate-x-0"
        >
          <Icon
            class="control-arrow pointer-events-auto mx-2.5 cursor-pointer text-sm text-white !outline-0"
            name="bi:arrow-left"
            size="30"
          />
        </UiCarouselPrevious>
        <UiCarouselContent class="gap-4 overflow-visible">
          <UiCarouselItem
            v-for="(image, i) in props.images"
            :key="i"
            class="data-gallery group flex basis-auto flex-col items-center justify-center"
          >
            <UiGalleryThumbnail :image="image" @show-image="showImg(i)" />
          </UiCarouselItem>
        </UiCarouselContent>
        <UiCarouselNext
          class="group absolute right-2 top-1/2 z-10 mx-auto flex -translate-y-1/2 translate-x-0"
        >
          <Icon
            class="control-arrow pointer-events-auto mx-2.5 cursor-pointer text-sm text-white !outline-0"
            name="bi:arrow-right"
            size="30"
          />
        </UiCarouselNext>
      </UiCarousel>
    </div>
  </div>
  <UiLightbox
    v-model="visible"
    :index="index"
    :images="props.images.map((image) => withHost(image.originalUrl))"
  />
</template>

<style>
.gallery-control [aria-disabled='true'] {
  visibility: hidden;
}
</style>
